import React from 'react';
import styled from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faImages } from '@fortawesome/pro-regular-svg-icons';
import { faThumbsUp, faVideo } from '@fortawesome/pro-solid-svg-icons';
import Card from '@tovia/man-ui/lib/components/Card/Card';
import { Link } from 'react-router-dom';
import RatingOverlay from '@tovia/man-ui/lib/components/RatingOverlay/RatingOverlay';
import Badges from '@tovia/man-ui/lib/components/Badge/Badges';
import Badge from '@tovia/man-ui/lib/components/Badge/Badge';
import { BlurrableLazyImage } from 'src/client/components/ui/BlurredImage';
import { RatingStars } from 'src/@types/shared';

type Props = {
  favoriteCount?: number;
  galleriesCount?: number;
  imgAlt: string;
  imgSrc: string;
  isBlurred: boolean;
  moviesCount?: number;
  name: string;
  ratingStars: RatingStars;
  url: string;
  views?: number | string;
};

export default function ModelDetailedCard(props: Props) {
  const {
    url,
    imgSrc,
    imgAlt,
    favoriteCount = 0,
    views = 0,
    name,
    ratingStars,
    galleriesCount = 0,
    moviesCount = 0,
    isBlurred,
  } = props;

  const ratingMessage = ratingStars.userRating ? 'Your Rating' : 'Rating';
  const usersRating = ratingStars.rating !== 0 ? ratingStars.rating : 'Not rated yet';

  // The type exported from the component is wrong, it's missing the 'rating'
  // parameter in the submitRating function
  const ratingStarsFixedType = ratingStars as Parameters<typeof RatingOverlay>[0]['ratingStars'];

  return (
    <Wrapper className="detailed-card-wrapper">
      <Card>
        <div className="photo">
          <Link to={url}>
            <BlurrableLazyImage
              src={imgSrc}
              alt={imgAlt}
              width="100%"
              height="100%"
              lazy
              animate
              $isBlurred={isBlurred}
            />
          </Link>
        </div>
        <div className="photo-stats">
          <h3>
            <Link to={url}>{name}</Link>
          </h3>
          <div className="attrs">
            <div className="attr">
              <span className="attr-label">{ratingMessage}: </span>
              <span className="attr-value">
                <RatingOverlay ratingStars={ratingStarsFixedType}>
                  <span className="rating-overlay">
                    {ratingStars.userRating ? ratingStars.userRating : usersRating}
                  </span>
                </RatingOverlay>
              </span>
            </div>
          </div>
          <Badges>
            {galleriesCount > 0 && (
              <Badge key="photos" text={galleriesCount} icon={<FontAwesomeIcon icon={faImages} />} />
            )}
            {moviesCount > 0 && <Badge key="movies" text={moviesCount} icon={<FontAwesomeIcon icon={faVideo} />} />}
            <Badge key="views" text={views} icon={<FontAwesomeIcon icon={faEye} />} />
            <Badge key="favorites" text={favoriteCount} icon={<FontAwesomeIcon icon={faThumbsUp} />} />
          </Badges>
        </div>
      </Card>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  &:not(.menu-opened) {
    &:hover {
      .card-menu-overlay {
        opacity: 1;
      }
    }
  }

  .card-menu-overlay {
    transition: 0.3s opacity;
    opacity: 0;
    color: #fff;
  }

  .card-info-1 {
    padding-bottom: 0;
  }
  .card-info-2 {
    padding-top: 0;
  }

  .card-media {
    overflow: hidden;
  }
`;
